var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 184.912,
    viewBox: "0 0 268 184.912",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    x2: "100%",
    y1: "26.197%",
    y2: "73.803%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7A5EA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51.205%",
    stopColor: "#A1628E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C96675",
    stopOpacity: 0.5
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    fillRule: "evenodd",
    stroke: "url(#a)",
    d: "M285.378776,167.504947 C285.750085,167.47484 286.13254,167.582194 286.44326,167.833726 L290.369126,172.410998 L390,172.411945 C397.870058,172.411945 404.995058,175.601916 410.152543,180.759402 C415.310029,185.916887 418.5,193.041887 418.5,200.911945 L418.5,322.911945 C418.5,330.782003 415.310029,337.907003 410.152543,343.064488 C404.995058,348.221974 397.870058,351.411945 390,351.411945 L180,351.411945 C172.129942,351.411945 165.004942,348.221974 159.847457,343.064488 C154.689971,337.907003 151.5,330.782003 151.5,322.911945 L151.5,200.911945 C151.5,193.041887 154.689971,185.916887 159.847457,180.759402 C165.004942,175.601916 172.129942,172.411945 180.000005,172.411945 L280.631188,172.410998 L284.357091,168.028568 C284.625356,167.712962 284.996148,167.53597 285.378776,167.504947 Z",
    transform: "translate(-151 -167)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBackground);
export default __webpack_public_path__ + "static/media/menu_background.6b0b021dfede81760f8e281dee4d49f4.svg";
export { ForwardRef as ReactComponent };